import { Search, Command } from "lucide-react";
import { useEffect, useRef, useState } from "react";

/**
 * Barre de recherche Spotlight (style macOS).
 * Gros champ, arrondi, raccourci ⌘K visible.
 * Aucune logique métier — cible plus tard :
 *   client · véhicule · bon de commande · immatriculation · VIN
 */
const SpotlightSearch = () => {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div
      data-testid="spotlight-search"
      className={[
        "relative w-full rounded-2xl bg-white border transition-all duration-200",
        focused
          ? "border-[#111111] shadow-[0_12px_40px_-12px_rgba(17,17,17,0.15)]"
          : "border-[#EEF2F5] shadow-[0_1px_2px_rgba(17,17,17,0.03)]",
      ].join(" ")}
    >
      <div className="flex items-center gap-4 px-5 py-4">
        <Search size={20} strokeWidth={1.75} className="text-[#9CA3AF] shrink-0" />
        <input
          ref={inputRef}
          data-testid="spotlight-input"
          placeholder="Rechercher un client, véhicule, bon de commande, immatriculation, VIN…"
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          className="flex-1 bg-transparent outline-none text-[15px] text-[#111111] placeholder:text-[#9CA3AF] tracking-tight"
        />
        <kbd
          className="hidden md:inline-flex items-center gap-1 rounded-md border border-[#EEF2F5] bg-[#F7F8FA] px-2 py-1 text-[11px] font-medium text-[#6B7280]"
          aria-hidden
        >
          <Command size={10} strokeWidth={2.25} />
          K
        </kbd>
      </div>
    </div>
  );
};

export default SpotlightSearch;
